import React from 'react';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { withDynamicComponent, withDynamicImport } from '@thd-nucleus/app-render';
import { withErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { defaultProps, propTypes } from './fbr.util';
import { FBRPlaceholder } from './FBRPlaceholder/FBRPlaceholder';
import { dataModel } from './dataModel';
import { FeatureBasedRecommendations as FeatureBasedRecommendationsSSR } from './FeatureBasedRecommendations.component?clientSideRemove';

const placeholder = (
  <FBRPlaceholder
    color="#E0E0E0"
    showLoadingAnimation
  />
);

const ImportedComponent = withDynamicImport({
  server: () => {
    // For Vite SSR - return the conditionally imported component
    return FeatureBasedRecommendationsSSR;
  },
  client: () => {
    return import('./FeatureBasedRecommendations.component');
  },
  placeholder,
  name: 'FeatureBasedRecommendations',
});

const HydratedComponent = withHydrator({
  delay: 1500,
  id: 'product-section-fbr',
  placeholder,
  preserveCtxVal: 'clientStore',
  scrollBuffer: 750,
}, ImportedComponent);

const DynamicComponent = withDynamicComponent(HydratedComponent,
  { placeholder }
);

const fbrdataModel = dataModel;

export const FeatureBasedRecommendationsImporter = withErrorBoundary(DynamicComponent);

FeatureBasedRecommendationsImporter.displayName = 'FeatureBasedRecommendationsImporterVite';
FeatureBasedRecommendationsImporter.propTypes = propTypes;
FeatureBasedRecommendationsImporter.defaultProps = defaultProps;
FeatureBasedRecommendationsImporter.dataModel = fbrdataModel;